import { DEFAULT_INTL_ACTIONS, useIntlConfigurationStoreCare, useIntlConfigurationStorePortal } from "@akina/infra";

const useIntlCare = () => {
  const { intl } = useIntlConfigurationStoreCare();
  if (!intl) return DEFAULT_INTL_ACTIONS;
  return { ...intl };
};

const useIntlPortal = () => {
  const { intl } = useIntlConfigurationStorePortal();
  if (!intl) return DEFAULT_INTL_ACTIONS;
  return { ...intl };
};

export const getUseIntl = {
  care: useIntlCare,
  portal: useIntlPortal,
};
